export const BORDER_WIDTH = 2;
export const ACTIVE_SCALE_FACTOR = 0.9;
